import { cloneDeep } from "lodash";
import {
    updateStateAfterWidgetOptionChange,
    isMdaeWidgetOptionChangeEvent,
} from "../../../mdae-framework";
import {
    actionTypes as asyncTypes,
    isAsyncOperation,
    isAsyncComplete,
} from "async-ops";
import { GET_CURRENT_USER } from "../services/get-current-user";
import { GET_THOUGHT_SPOT_SETTINGS } from "../services/get-thought-spot-settings";
import { GET_APPLICATION_CONFIGURATIONS } from "../services/get-application-configurations";
import { GET_CLIENT_LIST } from "../services/get-client-list";
export const SET_MDAE_NAVIGATION_BAR_CONFIG = "SET_MDAE_NAVIGATION_BAR_CONFIG";
export const SET_EMDR_UNSEEN_DOC_COUNT="SET_EMDR_UNSEEN_DOC_COUNT";


const initialState = {
    auditGroups: [],
    navigationBarConfig: {
        isMdaeNavigationBarExpanded: false,
        mdaeNavigationBarDrawerHeight: 0,
        mdaeNavigationBarListWidth: 0,
        mdaeNavigationBarItemList: [],
    },
    notificationCounts:[]
};

export default function (state = initialState, action) {
    let newState;
    switch (action.type) {
        case SET_MDAE_NAVIGATION_BAR_CONFIG:
            newState = {...state};
            if (isMdaeWidgetOptionChangeEvent(action.data)) {
                newState = updateStateAfterWidgetOptionChange(newState, action.data);
            } else {
                newState = { ...newState, ...action.data };
            }
            return newState;
        case SET_EMDR_UNSEEN_DOC_COUNT:
            return {
                ...state,
                notificationCounts: [{name: "Inbox", count: action.noOfDocSeen}]
            }; 
        case asyncTypes.OPERATION:
        case asyncTypes.COMPLETE:
        case asyncTypes.FAILURE:
            if (isAsyncOperation(GET_CURRENT_USER)(action)) {
                return { ...state, currentUser: {} };
            }
            if (isAsyncComplete(GET_CURRENT_USER)(action)) {
                const loggedInUserDisaplyName =
                    action.response.firstName.charAt(0).toUpperCase() +
                    ". " +
                    (action.response.lastName.charAt(0).toUpperCase() +
                        action.response.lastName.slice(1));

                const userFeatureKeys = action.response.userPermissions.userFeatureKeys;
                let isHayesGeneralAccess = false;
                userFeatureKeys.forEach((element) => {
                    if (
                        element.featureGroupName.toUpperCase() == "HAYES GENERAL ACCESS"
                    ) {
                        isHayesGeneralAccess = true;
                    }
                });

                return {
                    ...state,
                    currentUser: {
                        ...action.response,
                        loggedInUserDisaplyName: loggedInUserDisaplyName,
                        isHayesGeneralAccess: isHayesGeneralAccess,
                    },
                };
            }
            if (isAsyncOperation(GET_THOUGHT_SPOT_SETTINGS)(action)) {
                return { ...state, thoughtSpotSettings: {} };
            }
            if (isAsyncComplete(GET_THOUGHT_SPOT_SETTINGS)(action)) {
                return {
                    ...state,
                    thoughtSpotSettings: action.response,
                };
            }
            if (isAsyncOperation(GET_APPLICATION_CONFIGURATIONS)(action)) {
                return { ...state, applicationConfigurations: {} };
            }
            if (isAsyncComplete(GET_APPLICATION_CONFIGURATIONS)(action)) {
                return {
                    ...state,
                    applicationConfigurations: action.response,
                };
            }
            if (isAsyncOperation(GET_CLIENT_LIST)(action)) {
                return { ...state, clientConfigSetting: {} };
            }
            if (isAsyncComplete(GET_CLIENT_LIST)(action)) {
                return {
                    ...state,
                    clientConfigSetting: action.response.result,
                };
            }             
             return state;
        default:
            return state;
    }
}
